import type { Moment } from "@msuite/utils/date";
import { Button, ButtonGroup } from "../button";
import { Icon } from "../icons";
import { useTranslation } from "../localization";

/** Props Interface */
interface WeekPickerProps {
	currentWeek: Moment;
	onBack: () => void;
	onForward: () => void;
}

export function WeekPicker({ currentWeek, onBack, onForward }: WeekPickerProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<ButtonGroup isAttached={false}>
			<Button
				icon={<Icon name="ChevronLeft" />}
				onClick={onBack}
			/>
			<Button>{currentWeek.format(`[${t("dates.calendarweek")}] WW/YYYY`)}</Button>
			<Button
				icon={<Icon name="ChevronRight" />}
				onClick={onForward}
			/>
		</ButtonGroup>
	);
}
